import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  toggleActiveAuthPopUp,
  setActiveContestPopUp,
  setSignupFlow,
  setContestStep,
  toggleActiveContestPopUp,
  fetchContestItems
} from '../../actions/contest';
import { USER_NOT_CONFIRMED } from '../../constants';

import SignUp from '../Auth/SignUp';
import Login from '../Auth/Login';
import Verify from '../Auth/Verify';
import ForgotPassword from '../Auth/ForgotPassword';

import { withTranslation } from 'react-i18next';

import closeIcon from '../../images/icons/icon_close_black.svg';

class AuthPopup extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    const {
      authError,
      setSignupFlow,
      email,
      signupFlow,
      signedIn,
      toggleActiveAuthPopUp
    } = this.props;

    // Login success
    if (signupFlow === 'login' && signedIn) {
      toggleActiveAuthPopUp(false);
    }

    // Signup success
    if (signupFlow === 'signup' && email !== '') {
      setSignupFlow('verify');
    }

    // Login but user hasn't verify
    if (authError && authError.code === USER_NOT_CONFIRMED) {
      setSignupFlow('verify');
    }

  }
  
  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  render() {
    const {
      signupFlow,
      signedIn,
      toggleActiveAuthPopUp,
      authError,
      setSignupFlow
    } = this.props;
    document.body.style.overflow = 'hidden';
    const modalScroll = () => {
      toggleActiveAuthPopUp(false);
      document.body.style.overflow = 'auto';
    }
    return (
      <>
        <div
          className='fe-overlay'
          onClick={modalScroll}
        />
        <div
          className='fe-contest-popup-container '
          onKeyDown={this.handleKeyPress}
          ref={this.popupRef}
          tabIndex='0'
        >
          <div className='fe-close'>
            <div
              onClick={modalScroll}
              style={{ cursor: 'pointer' }}
            >
              <img src={closeIcon} alt='' />
            </div>
          </div>
          <div className='fe-contest-popup-details popUpLogin'>
            {
              {
                signup: <SignUp contest />,
                login: <Login contest />,
                verify: <Verify contest />,
                resetPassword: <ForgotPassword contest />
              }[signupFlow]
            }
          </div>
        </div>
      </>
    );
  }
}

AuthPopup.propTypes = {
  toggleActiveAuthPopUp: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ contestState, authState }) => ({
  signedIn: authState.signedIn,
  authError: authState.authError,
  email: authState.email,
  signupFlow: contestState.signupFlow,
  hasVoted: contestState.hasVoted,
  activeContestId: contestState.activeContestId,
  contestLoading: contestState.loading
});

const mapDispatchToProps = {
  setActiveContestPopUp,
  toggleActiveAuthPopUp,
  toggleActiveContestPopUp,
  setSignupFlow,
  setContestStep,
  fetchContestItems
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AuthPopup)
);
